export enum CertificateCriteriaTypeCourse {
  MOOC = 'mooc',
  FREE = 'free',
}

export interface ICertificateCriteria {
  _id?: string
  modality: string
  typeCourse?: CertificateCriteriaTypeCourse
  certificateCriteria: string
}

export type ICertificateCriteriaCreateParams = Omit<ICertificateCriteria, '_id'>

export type ICertificateCriteriaUpdateParams = Partial<ICertificateCriteriaCreateParams> & {
  id: string
}

export interface ICertificateCriteriaListParams {
  pageNumber?:string, // Numero de pagina
  nPerPage?:string, // Cantidad de elementos por pagina
  select?: string, // Campos de la coleccion a buscar
  search?:string, // Busca sobre los campos de la coleccion
}

export interface ICertificateCriteriaGetByIdParams {
  id: string
}

export interface ICertificateCriteriaDeleteParams {
  id: string
}
